#import "../fragments/event-fragment-sparse.graphql"
#import "../fragments/pinned-info-fragment.graphql"

query GetEvents(
    $entityId: ID
    $first: Int!
    $before: String
    $after: String
    $filters: TimelineEventsFilterInput
) {
    events(entityId: $entityId, first: $first, before: $before, after: $after, filters: $filters) {
        pageInfo {
            startCursor
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...EventFragmentSparse
            }
            pinnedInfo {
                ...PinnedInfoFragment
            }
        }
    }
}
